import { useIsShellHosted } from 'lib/context/ShellContext/ShellContext';

export const PRIMARY_NEW_BUTTON = { variant: 'primary', color: 'primary' };
const LINK = { variant: 'link' };

export const useNewButtonStyle = () => (useIsShellHosted() ? PRIMARY_NEW_BUTTON : LINK);

export default useNewButtonStyle;
